"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMeasuresToSecondaryAxis = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var common_1 = require("../_util/common");
function setMeasuresToSecondaryAxis(config, dv) {
    var _a;
    if (config === void 0) { config = {}; }
    var isDualAxis = (_a = config.dualAxis) !== null && _a !== void 0 ? _a : true;
    var type = config.type;
    var secondaryYAxis = config.secondary_yaxis, remainConfig = tslib_1.__rest(config, ["secondary_yaxis"]);
    var secondaryMeasuresIds = dv.def().bucketMeasures(sdk_ui_1.BucketNames.SECONDARY_MEASURES).map(sdk_model_1.measureLocalId);
    if (!common_1.isComboChart(type)) {
        return config;
    }
    if (!isDualAxis) {
        return remainConfig;
    }
    return tslib_1.__assign(tslib_1.__assign({}, remainConfig), { secondary_yaxis: tslib_1.__assign(tslib_1.__assign({}, secondaryYAxis), { measures: secondaryMeasuresIds }) });
}
exports.setMeasuresToSecondaryAxis = setMeasuresToSecondaryAxis;
//# sourceMappingURL=dualAxis.js.map